export default {
  // New Functions for Biotrue CMS

	
  setSelections(state, val) {
    console.debug(val.selections);
    state.selections = val.selections
  }
}



// WEBPACK FOOTER //
// ./src/Homepage/store/mutations.js